<jmkw-button
  #button
  [iconName]="iconName"
  [id]="id"
  [automationKey]="automationKey"
  [active]="!!active"
  [hover]="!!hover"
  [tooltipText]="tooltipText"
  (onClick)="onClickHandler($event, button)"
>
</jmkw-button>
